// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"style_mainSection__T7VnM"};